module.exports = __webpack_public_path__ + "img/28401-041_1.99c1678f.jpg";